
export class FileResponse {
  constructor(
    public fileName?: string,
    public fileDownloadUri?: string,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/FileResponse.model.ts